import { gql } from '@apollo/client'
import React from 'react'

import { formsClient } from '../../../../utils/apollo/api'
import { useNavigation } from '../../../../utils/contexts/NavigationContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import { useServiceOrder } from './ServiceOrderLoader'
import Button from '../../../../packages/kiti/components/actions/Button'
import Center from '../../../../packages/kiti/components/helpers/Center'
import IconBlock from '../../../../components/presentation/IconBlock'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import window from '../../../../utils/helpers/window'

const Context = React.createContext([])
const { Provider } = Context
export const useFormReplyState = () => React.useContext(Context)
export const useFormReply = () => useFormReplyState()?.formReply

const QUERY = gql`
  query FormReply($id: ID) {
    formReply(id: $id) {
      id
      number
      formId
      insertedAt
      replies {
        id
        value
        notes
        questionId
        insertedAt
        documents {
          id
          src
          type
          description
        }
        question {
          id
          name
          ordination
          categoryOrdination
          type {
            id
            name
          }
          category {
            id
            name
          }
        }
      }
    }
  }
`

const FormReplyLoader = ({ children, id }) => {
  const navigate = useNavigation()
  const serviceOrder = useServiceOrder()
  const formReplyId = serviceOrder.formReplyId

  let { data, ...state } = useQuery(QUERY, {
    variables: { id: formReplyId },
    skip: !formReplyId,
    client: formsClient
  })

  if (!formReplyId && !!serviceOrder.parentId) {
    const retirect = () => navigate(window.location.pathname.replace(serviceOrder.id, serviceOrder.parentId))

    return (
      <Center>
        <IconBlock
          icon="RiFileWarningLine"
          title="Atividade sem suporte para esse documento"
          subtitle="O ideal é acessar diretamente a atividade pai para gerar o documento corretamente"
        >
          <Button onClick={retirect}>Acessar atividade pai</Button>
        </IconBlock>
      </Center>
    )
  }

  return (
    <StatePresenter {...state} empty={!data?.formReply}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FormReplyLoader
